import i18n from 'i18n';

import { AccordionProps } from './AccordionItem';

export const FAQ_ITEMS: Pick<AccordionProps, 'title' | 'text'>[] = [
  {
    title: i18n.t('main.faq.items.getStarted.title', { ns: 'careerHub' }),
    text: i18n.t('main.faq.items.getStarted.text', { ns: 'careerHub' }),
  },
  {
    title: i18n.t('main.faq.items.freeTrial.title', { ns: 'careerHub' }),
    text: i18n.t('main.faq.items.freeTrial.text', { ns: 'careerHub' }),
  },
  {
    title: i18n.t('main.faq.items.paymentMethods.title', { ns: 'careerHub' }),
    text: i18n.t('main.faq.items.paymentMethods.text', { ns: 'careerHub' }),
  },
  {
    title: i18n.t('main.faq.items.onboardingDuration.title', {
      ns: 'careerHub',
    }),
    text: i18n.t('main.faq.items.onboardingDuration.text', { ns: 'careerHub' }),
  },
  {
    title: i18n.t('main.faq.items.customerSupport.title', { ns: 'careerHub' }),
    text: i18n.t('main.faq.items.customerSupport.text', { ns: 'careerHub' }),
  },
  {
    title: i18n.t('main.faq.items.exportData.title', { ns: 'careerHub' }),
    text: i18n.t('main.faq.items.exportData.text', { ns: 'careerHub' }),
  },
  {
    title: i18n.t('main.faq.items.cancelSubscription.title', {
      ns: 'careerHub',
    }),
    text: i18n.t('main.faq.items.cancelSubscription.text', { ns: 'careerHub' }),
  },
];
